import PropTypes from 'prop-types'
import React from 'react'

import {
  ContainerTopColumnFull,
  ColumnFullFirtsLine,
  ColumnFullId,
  ColumnFullDate,
  ColumnFullTitle,
  ColumnFullSecondaryText,
  ColumnFullTertiaryText
} from '../../styled-components'

import { listItemListViewVariantOptions } from '../../constants'

import { IsLoading } from '../list-items-item'

import { DateTime } from 'luxon'

const CenterContainerMainContent = ({
  id,
  date,
  title,
  titleStyle,
  secondaryText,
  tertiaryText,
  style,
  listViewType
}) => {
  const toDateTime = (date) => {
    if (date instanceof DateTime) {
      return date.toFormat('dd LLL yy, h:mma').toLowerCase()
    } else if (date instanceof Date) {
      return DateTime.fromJSDate(date)
        .toFormat('dd LLL yy, h:mma')
        .toLowerCase()
    }

    return date
  }

  const dateToDateTime = toDateTime(date)

  return (
    <ContainerTopColumnFull listViewVariant={listViewType}>
      <ColumnFullFirtsLine>
        {id && (
          <IsLoading skeletonStyle={{ width: '20px' }}>
            <ColumnFullId colorTheme={style.secondaryColor ?? style.color}>
              {id}
            </ColumnFullId>
          </IsLoading>
        )}
        {dateToDateTime && (
          <IsLoading skeletonStyle={{ width: '75px' }}>
            <ColumnFullDate colorTheme={style.secondaryColor ?? style.color}>
              {dateToDateTime}
            </ColumnFullDate>
          </IsLoading>
        )}
      </ColumnFullFirtsLine>
      {title && (
        <IsLoading skeletonStyle={{ width: '130px' }}>
          <ColumnFullTitle style={titleStyle} colorTheme={style.color}>
            {title}
          </ColumnFullTitle>
        </IsLoading>
      )}
      {secondaryText && (
        <IsLoading skeletonStyle={{ width: '100px' }}>
          <ColumnFullSecondaryText
            colorTheme={style.secondaryColor ?? style.color}
          >
            {secondaryText}
          </ColumnFullSecondaryText>
        </IsLoading>
      )}
      {tertiaryText && (
        <IsLoading skeletonStyle={{ width: '100px' }}>
          <ColumnFullTertiaryText
            colorTheme={style.secondaryColor ?? style.color}
          >
            {tertiaryText}
          </ColumnFullTertiaryText>
        </IsLoading>
      )}
    </ContainerTopColumnFull>
  )
}

CenterContainerMainContent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.instanceOf(DateTime)
  ]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tertiaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  style: PropTypes.object,
  listViewType: PropTypes.oneOf(Object.values(listItemListViewVariantOptions))
}

export default CenterContainerMainContent
